module.exports = __webpack_public_path__ + "static/media/cross.6a06956b.svg";